<template>
  <WTooltip :position="tooltipPosition" :label="sla">
    <em
      :class="['channel-sla', 'channel-sla--' + [slaClassByWaitingTime]]"
    ></em>
  </WTooltip>
</template>

<script>
import { WTooltip } from '@alice-health/wonderland-vue'
import differenceInMinutes from 'date-fns/differenceInMinutes'

export default {
  components: { WTooltip },
  props: {
    channel: {
      type: Object,
      default() {
        return {}
      }
    },
    tooltipPosition: { type: String, default: undefined }
  },
  computed: {
    slaClassByWaitingTime() {
      if (!this.channel.isWaiting) {
        return 'success'
      }

      const date = this.channel.waitingSince

      const lastMessageDate = date?.toDate()
      const diffInMinutes = differenceInMinutes(new Date(), lastMessageDate)

      if (diffInMinutes < 5) return 'alert'
      if (diffInMinutes < 10) return 'warning'
      return 'danger'
    },
    sla() {
      return this.channel.isWaiting ? 'Aguardando resposta' : 'Respondido'
    }
  }
}
</script>

<style lang="scss" scoped>
.channel-sla {
  display: inline-block;
  background: var(--sys-color-surface-background-default);
  width: 10px;
  height: 10px;
  border-radius: 10px;

  &--success {
    background: var(--gl-color-shades-gray-60);
  }

  &--alert {
    background: var(--sys-color-surface-container-success);
  }

  &--warning {
    background: var(--gl-color-shades-yellow-60);
  }

  &--danger {
    background: var(--sys-color-surface-container-error);
  }
}
</style>
